import { render } from "./EditNewLoyerModal.vue?vue&type=template&id=e1660436"
import script from "./EditNewLoyerModal.vue?vue&type=script&lang=js"
export * from "./EditNewLoyerModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__